export default {
  name: 'Footer section - 1',
  tab: 'footer',
  type: 'footer-default-section',
  content: {
    title: 'Footer section',

    'content-subtitle': 'Contact us',
    'content-text': `
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> 
      <p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
    `,

    'menu-subtitle': 'Navigation',
    menu: 'default',

    'social-media-subtitle': 'Social media',
    'social-media': `[
      {
        "social-media-label": "Facebook",
        "social-media-link": "https://www.facebook.com",
        "social-media-icon": "facebook"
      },
      {
        "social-media-label": "Instagram",
        "social-media-link": "https://www.instagram.com",
        "social-media-icon": "instagram"
      },
      {
        "social-media-label": "Linkedin",
        "social-media-link": "https://www.linkedin.com",
        "social-media-icon": "linkedin"
      },
      {
        "social-media-label": "Email",
        "social-media-link": "mailto:post@kloner.no",
        "social-media-icon": "email"
      }
    ]`
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '0',
    'padding-top': '60px',
    'padding-bottom': '60px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'subtitle-color': 'inherit',
    'subtitle-font-weight': 'var(--title-font-weight)',
    'subtitle-tag': 'h5',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {
    'active-style': 'default'
  }
}
